import React, { useState, useEffect } from "react";
import "../css/nav.css";
import { AlignJustify, ArrowRightCircle, User, GitHub, BookOpen, Linkedin } from "react-feather";

const NavBar = () => {
    const [subNavVisible, setSubVisible] = useState(false);

    const scrollTo = (id) => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
        setSubVisible(false);
    };

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 700 && subNavVisible) {
                setSubVisible(false);
            }
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [subNavVisible]);

    return (
        <div className="navbar-container">
            <div className="leftside-nav">
                <img className="nav-dvh" src="dvh.png" alt="dvh_image" />
            </div>

            <div className="rightside-nav">
                <h1 className="nav-aboutme" onClick={() => scrollTo("about")}>
                    About Me
                </h1>
                <h1 className="nav-education" onClick={() => scrollTo("education")}>
                    Education
                </h1>
                <h1 className="nav-experience" onClick={() => scrollTo("experience")}>
                    Experience
                </h1>
                <h1 className="nav-projects" onClick={() => scrollTo("projects")}>
                    Projects
                </h1>

                <AlignJustify className="nav-menu-icon" onClick={() => setSubVisible((prev) => !prev)} />
            </div>

            <div className={`response-nav-container ${subNavVisible ? "slide-out" : ""}`}>
                <div className="response-nav-body">
                    <div className="sidebar-header">
                        <ArrowRightCircle className="sidebar-close-button" onClick={() => setSubVisible((prev) => !prev)} />
                    </div>

                    <div className="sidebar-item" onClick={() => scrollTo("about")}>
                        <User className="sidebar-icon" />
                        <h2 className="sidebar-icon-title">About Me</h2>
                    </div>

                    <div className="sidebar-item" onClick={() => scrollTo("education")}>
                        <BookOpen className="sidebar-icon" />
                        <h2 className="sidebar-icon-title">Education</h2>
                    </div>
                    <div className="sidebar-item" onClick={() => scrollTo("experience")}>
                        <Linkedin className="sidebar-icon" />
                        <h2 className="sidebar-icon-title">Experience</h2>
                    </div>

                    <div className="sidebar-item" onClick={() => scrollTo("projects")}>
                        <GitHub className="sidebar-icon" />
                        <h2 className="sidebar-icon-title">Projects</h2>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NavBar;
